import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import ImageNotAvail from 'Assets/png/companyLogo.png';

const LazyImage = image => {
  return (
    <div className={image.parentClass ? image.parentClass : ''}>
      <LazyLoadImage
        className={image.clsName ? image.clsName : ''}
        alt={image.alt}
        threshold={image.threshold ? image.threshold : 50}
        src={image.src !== null ? image.src : ImageNotAvail}
      />
      <span>{image.caption}</span>
    </div>
  );
};

export { LazyImage };
export default LazyImage;
